<template>
  <div>
    <template v-for="field in fields">
      <RangeInput v-if="field.type == 'range-input'" :fields="field" />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput
        v-else-if="field.type == 'button-group'"
        type="group"
        name="shipment_type"
        :label="$t('delivery.fields.deliveryType')"
        :value="(formValues.shipment_type = shipment_type)"
      >
        <div class="mc-modal__filter-button-group">
          <template v-for="item in shipmentTypeOptions">
            <button
              :key="`${item.key}-${btnKey}`"
              type="button"
              :class="{ 'mc-modal__filter-button--active': shipment_type[item.key] }"
              class="mc-modal__filter-button"
              @input="$emit('update:formValues', { key: field.name, value: $event })"
              @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
              @click="filterStatus(item.key)"
            >
              {{ item.label }}
            </button>
          </template>
        </div>
      </FormulateInput>
      <FormulateInput v-else v-bind="field" />
    </template>
  </div>
</template>

<script>
import RangeInput from './wrapper/RangeInput'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import { tableFilterFields } from './lib/tableFilterFields'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  props: {
    formValues: {},
    fullObjects: {},
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      fields: tableFilterFields((key) => this.$t(key)).filter((field) => field.isShow),
      btnKey: 0,
    }
  },
  computed: {
    ...mapState('delivery', ['shipmentTypeFilters']),
    shipment_type: {
      get() {
        return Object.keys(this.shipmentTypeFilters).length > 0
          ? this.shipmentTypeFilters
          : { all: true }
      },
      set(value) {
        this.setShipmentTypeFilters(value)
      },
    },
    shipmentType() {
      return [
        {
          key: 'UNSCHEDULED',
          label: this.$t('delivery.status.nonScheduled'),
        },
        {
          key: 'TRANSIT',
          label: this.$t('delivery.status.transit'),
        },
        {
          key: 'DIRECT',
          label: this.$t('delivery.status.direct'),
        },
      ]
    },
    shipmentTypeOptions() {
      const data = this.shipmentType
      data.unshift({
        key: 'all',
        label: this.$t('global.filter.all'),
      })
      return data
    },
  },
  methods: {
    ...mapActions('delivery', ['setShipmentTypeFilters']),
    filterStatus(key) {
      if (key == 'all') {
        this.shipment_type = this.shipmentTypeOptions.reduce((acc, item) => {
          acc[item.key] = false
          return acc
        }, {})
        this.shipment_type.all = true
      } else {
        this.shipment_type.all = false
        this.shipment_type[key] = !this.shipment_type[key]
        let obj = { ...this.shipment_type }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })
        if (objArr.length === this.shipmentType.length || objArr.length === 0) {
          this.shipment_type = this.shipmentTypeOptions.reduce((acc, item) => {
            acc[item.key] = false
            return acc
          }, {})
          this.shipment_type.all = true
          return
        }
      }
      this.btnKey += 1
      this.setShipmentTypeFilters(this.shipment_type)
    },
  },
}
</script>
